import { createFileRoute } from '@tanstack/react-router'
import ContactPage from '#/pages/ContactPage'
import { faqsQueryOptions } from '#/features/faqs/hooks/useFaqs'
import { coursesQueryOptions } from '#/features/courses/hooks/useCourses'

export const Route = createFileRoute('/_home/contact')({
  loader: async ({ context: { queryClient } }) => {
    await Promise.all([
      queryClient.ensureQueryData(faqsQueryOptions()),
      queryClient.ensureQueryData(coursesQueryOptions({ limit: 5 })),
    ])
  },
  head: () => ({
    meta: [
      {
        title: "Contact Us | Wa'allamah",
      },
      {
        name: 'description',
        content:
          "Get in touch with Wa'allamah Academy for admissions, tutoring inquiries, and student support.",
      },
    ],
  }),
  component: ContactPage,
})
